module.exports = __webpack_public_path__ + "static/media/newseventcenter.346fb331.png";